import React from 'react';

import { MoreVert } from '@mui/icons-material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { UserOutput } from '@cnx-saas/common';

interface OverflowMenuProps {
  user: UserOutput;
  onResendInvitation(user: UserOutput): void;
  onDelete(user: UserOutput): void;
}

export function OverflowMenuInVited({
  user,
  onResendInvitation,
  onDelete,
}: OverflowMenuProps) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  return (
    <>
      <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
        <MoreVert />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <MenuItem
          onClick={async () => {
            setAnchorEl(null);
            onResendInvitation(user);
          }}
        >
          {t('userManagement.actionlabel.resendInvitation', {
            defaultValue: 'Resend Invitation',
          })}
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            onDelete(user);
          }}
        >
          {t('userManagement.actionlabel.revoke', { defaultValue: 'Revoke' })}
        </MenuItem>
      </Menu>
    </>
  );
}
